export enum TabsValue {
    POSTS = 'posts',
    COLLECTIONS = 'collections',
    MODERATION = 'moderation',
}

export enum SubcategoriesValue {
    SAVED = 'saved',
    CREATED = 'created',
    MODERATION = 'moderation',
    POSTS = 'posts',
}
